import { MerchantCustomerNotifier } from "@/services/autoMessage/response";
import { SmsTemplate } from "@/services/template/type";

import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export enum MessageType {
  all = "all",
  messageGroup = "messageGroup",
  custom = "custom",
}

type SetNotifierPayload = {
  notifier?: MerchantCustomerNotifier;
};

type SetTemplatePayload = {
  smsTemplate: SmsTemplate;
};

export type AutoMessageStore = {
  notifier?: MerchantCustomerNotifier;
  smsTemplate?: SmsTemplate;
  setNotifier: (command: SetNotifierPayload) => void;
  setTemplate: (command: SetTemplatePayload) => void;
};

const useAutoMessageStore = create<AutoMessageStore>()(
  devtools(
    persist(
      (set) => ({
        smsTemplate: undefined,
        notifier: undefined,
        setNotifier: (command) =>
          set((state) => ({
            ...state,
            ...command,
          })),
        setTemplate: (command) =>
          set((state) => ({
            ...state,
            ...command,
          })),
      }),
      { name: "createMessageState" }
    )
  )
);

export default useAutoMessageStore;
